export const AbTests = {
    'documentNr': ['documentNr - A', 'documentNr - B']
} as const;

export const variants = Object.values(AbTests).flat(1);

export type TestId = keyof typeof AbTests;
export type VariantIds = typeof variants;
export type VariantId = typeof variants[number];

export const AbTestUrls: { [key in TestId]: string } = {
    documentNr: "/register"
} as const;